<template>
  <div class="related-table">
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="tab.random"
        :label="tab.label"
        :name="tab.random">
        <DataTable
          :metas="tab.tableMetas"
          :showSetHeader="showSetHeader"
          @settingsClick="handleSettingsClick(...arguments, index)"
          @handleSetHeader="handleSetHeader(...arguments, index)">
        </DataTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getUserConfigFields, updateUserConfigFields } from "@inv/services/metaData/module/index.js";
import { relatedDataByReference } from "@inv/services/metaData/module/edit.js";
import DataTable from "../krDataTable";
export default {
  props: {
    options: kr.vue.getPropObject(),
    showSetHeader: kr.vue.getPropBoolean(true),
  },
  data() {
    return {
      activeTab: "",
      value: {},
      tabs: []
    }
  },
  computed: {
  },
  methods: {
    initTabs() {
      const { value, tabs, pageLayout, redirects } = this.options;
      const currentObjectApiName = value && value.object_describe_api_name;
      const currentDataId = value && value.id;
      if (tabs) {
        this.activeTab = tabs[0].random;
        tabs.forEach(tab => {
          const relatedField = tab.value && tab.value.relatedDataFrom;
          const relatedShow = tab.value && tab.value.relatedShow;
          const { objectDescribeApiName, targetApiName, targetRelatedListName } = relatedField;
          //判断是单选查找字段，还是多选查找字段
          const relatedApiName = currentObjectApiName === objectDescribeApiName ? targetApiName : objectDescribeApiName;
          tab.tableMetas = {
            api: relatedDataByReference,
            queryFieldsAPI: getUserConfigFields,
            updateFieldsAPI: updateUserConfigFields,
            opt: {
              moduleInfoId: relatedApiName,
              apiName: currentObjectApiName,
              dataId: currentDataId,
              pageSize: 5,
              relatedListName: targetRelatedListName,
              targetDescribeApiName: relatedApiName,
              layoutApiName: relatedShow && relatedShow.id,
              type: "relatedItems"
            },
            pageLayout,
            redirects,
            settingsType: "button",
            forceSetHeader: true
          }
        });
        this.tabs = tabs;
        this.value = value;
      }
    },
    handleSettingsClick(...args) {
      this.$emit('settingsClick', ...args);
    },
    handleSetHeader(...args) {
      this.$emit('handleSetHeader', ...args);
    },
    refreshData(index) {
      this.tabs[index].tableMetas = Object.assign({}, this.tabs[index].tableMetas);
      this.$nextTick(() => {
        this.$forceUpdate();
        //因为有可能几个tab是同样的相关项，需要同时刷新
        const { random, targetRelatedListName } = this.tabs[index];
        this.tabs.forEach(tab => {
          if (tab.random !== random && tab.targetRelatedListName === targetRelatedListName) {
            tab.tableMetas = Object.assign({}, tab.tableMetas);
          }
        });
      });
    }
  },
  components: {
    DataTable
  },
  watch: {
    options: {
      handler(v) {
        this.initTabs();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    kr.bus.$on('refreshPopoverData', this.refreshData);
  },
  beforeDestroy() {
    kr.bus.$off('refreshPopoverData');
  }
}
</script>

<style lang="scss">
.related-table {
  .el-tabs__header {
    margin-right: 30px;
    margin-bottom: 20px;
  }

  .el-tabs__nav-wrap::after {
    height: 1px !important;
  }

  .el-tabs__item {
    font-size: 14px;
    line-height: 20px;
    height: 34px;
    outline: none;
    color: #525975;

    &.is-active {
      color: $color-primary;
    }
  }

  .el-tabs__nav-prev,
  .el-tabs__nav-next {
    line-height: 32px;
  }
}

.related-popover-table {
  height: auto;
  padding: 20px;

  .el-table {
    margin-top: 0 !important;
  }

  > .el-popover__title {
    font-size: 14px !important;
    color: #9da2b3 !important;
    margin-bottom: 10px !important;
    color: #525975 !important;
    text-align: left;
    line-height: 20px;
    font-family: "PingFangSC-Medium";
  }
}
</style>
